/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of gang timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/
import TimesheetHarvestTable from './timesheet_gang_harvest_table';
import TimesheetWorkTable from './timesheet_modal_work_table';
import React from 'react';
const $ = window.$;


const TimesheetGangModal = ({ id, timesheet, submitGangTimesheet, payPeriodStartDate, payPeriodEndDate,
  prevPPStartDate, prevPPEndDate, user }) => {
  let tsCheck = '', empsWOHours = [], empsLessThan7 = [];
  if (!timesheet.emps) tsCheck = 'No employees selected';
  if (timesheet.emps.length > 0) {
    for (let e of timesheet.emps) {
      if (e.harvest.length === 0) empsWOHours.push(e);
      if (Number(e.summaryOfHours) < 8) empsLessThan7.push(e);
    }
  }
  $(document).ready(() => {
    $(`#${id}`).modal();
  });
  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Timesheet Summary</h4> <hr />
        {tsCheck}
        { empsWOHours.length > 0 ?
          <div>
            <h5 className="day-off">The follow employees do not have harvest records entered. Please verify this is correct.</h5>
            <ul>
            {
              empsWOHours.map((e) => (
                <li className="day-off" key={e.eid}>{ e.firstName } { e.lastName }</li>
              ))
            }
            </ul>
          </div>
          : ''
        }
        { empsLessThan7.length > 0 ?
          <div><hr />
            <h5 className="day-off">The follow employees have less than 8 hours. Please verify this is correct.</h5>
            <ul>
            {
              empsLessThan7.map((e) => (
                <li className="day-off" key={e.eid}>{ e.firstName } { e.lastName }</li>
              ))
            }
            </ul>
          </div>
          : ''
        }
        {
          timesheet.emps.map((e) => (
            <div key={e.eid} className="card horizontal z-depth-4">
              <div className="card-stacked">
                <div className="card-content">
                  <div>
                    <span className="flow-text"><b>{e.date}</b></span>
                    <div className="row ind-summary">
                      <div className="col s12 m6 l6">
                        <ul className="collection">
                          <li className="collection-item flow-text">Name: <b><span className="right">{e.firstName} {e.lastName}</span></b></li>
                          <li className="collection-item flow-text">Location: <b><span className="right">{ e.location }</span></b></li>
                          <li className="collection-item flow-text">Reg. Hours: <b><span className="right">{ e.regHours }</span></b></li>
                          <li className="collection-item flow-text">OT Hours: <b><span className="right">{ e.otHours > 0 ? <span className="day-off">{e.otHours}</span> : e.otHours }</span></b></li>
                          <li className="collection-item flow-text">Double Time Hours: <b><span className="right">{ e.doubleTime }</span></b></li>
                          <li className="collection-item flow-text ">Total Hours: <b><span className="right"><u>{ e.summaryOfHours }</u></span></b></li>
                        </ul>
                      </div>
                      <div className="col s12 m6 l6">
                        <ul className="collection">
                          <li className="collection-item flow-text">EID: <b><span className="right">{e.eid}</span></b></li>
                          <li className="collection-item flow-text">Start Time: <b><span className="right">{ e.startTime }</span></b></li>
                          <li className="collection-item flow-text">End Time: <b><span className="right">{ e.endTime }</span></b></li>
                          <li className="collection-item flow-text">Gang: <b><span className="right">{e.gang}</span></b></li>
                          <li className="collection-item flow-text">Grade: <b><span className="right">{e.grade}</span></b></li>
                          <li className="collection-item flow-text">Shift: <b><span className="right">{ e.shift }</span></b></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-action">
                  { e.subTimesheet.length > 0 ? <TimesheetWorkTable workPerformed={e.subTimesheet} /> : '' }
                  { e.harvest.length > 0 ? <TimesheetHarvestTable harvest={e.harvest} /> : '' }
                </div>
              </div>
            </div>
          ))
        }

      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        <button type="button" onClick={() => submitGangTimesheet(timesheet, { payPeriodStartDate, payPeriodEndDate, prevPPStartDate, prevPPEndDate }, user)} id="gang-ts-btn"
          className="modal-action modal-close waves-effect waves-green btn-flat">
          Submit
        </button>
      </div>
    </div>
  );
};

export default TimesheetGangModal;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_gang_modal.js